import { render } from "./steepTemplate.vue?vue&type=template&id=52511924&scoped=true"
import script from "./steepTemplate.vue?vue&type=script&lang=js"
export * from "./steepTemplate.vue?vue&type=script&lang=js"

import "./steepTemplate.vue?vue&type=style&index=0&id=52511924&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52511924"]])

export default __exports__